const FULL_WIDTH = '100%';

interface ResolveButtonSizePropsInput {
  isIconOnly: boolean;
  iconOnlySize: number | undefined;
  height?: number | string;
}

export interface ButtonSizeProps {
  width: number | string | undefined;
  height: number | string | undefined;
}

export function resolveButtonSizeProps({
  isIconOnly,
  iconOnlySize,
  height,
}: ResolveButtonSizePropsInput): ButtonSizeProps {
  if (isIconOnly) {
    return {
      width: iconOnlySize,
      height: height ?? iconOnlySize,
    };
  }

  return {
    width: FULL_WIDTH,
    height,
  };
}
